export const API_ENDPOINTS = {
  // Translation Workflow
  FETCH_TRANSLATIONS: '/th/Dashboard/GetTranslationRecords',
  APPROVE_TRANSLATION: '/th/Translations/ApproveTranslation',
  DECLINE_TRANSLATION: '/th/Translations/DeclineTranslation',
  CREATE_NEW_TRANSLATION: '/th/Translations/CreateNewTranslation',
  GENERATE_AI_TRANSLATION:'/th/Translations/GetAITranslation',
  DEACTIVATE_TRANSLATION: '/th/Translations/DeactivateTranslation',
  REACTIVATE_TRANSLATION: '/th/Translations/ReactivateTranslation',
  PROPOSE_TRANSLATION_EDIT: '/th/Translations/ProposeTranslationEdit',
  GET_TRANSLATION_RECORD_DETAILS: '/th/Dashboard/GetTranslationRecordDetails',
} as const;

export type ApiEndpoint = (typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS];
